class BrowseZeroResultsController {
}

const browseZeroResultsComponentDefinition = {
    bindings: {
        category: '<',
    },
    controller: BrowseZeroResultsController,
    template: require('./browse-zero-results.component.html').trim(),
};

module.exports = {
    BrowseZeroResultsController,
    browseZeroResultsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/browse-zero-results.component.js